import { render, staticRenderFns } from "./surface_post_reaction_vote.vue?vue&type=template&id=7a3c508e&scoped=true&"
import script from "./surface_post_reaction_vote.vue?vue&type=script&lang=js&"
export * from "./surface_post_reaction_vote.vue?vue&type=script&lang=js&"
import style0 from "./surface_post_reaction_vote.vue?vue&type=style&index=0&id=7a3c508e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3c508e",
  null
  
)

export default component.exports